import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  useParams,
  Link,
} from 'react-router-dom';

import { ModalProvider } from './Components/Providers/ModalContext';
import { NavMenuProvider } from './Components/Providers/NavMenuContext';

import './Styles/App.scss';
import Home from './Pages/Home';
import EnHome from './Pages/HomeEN';

const HomeWrapper = () => {
  const { lang } = useParams();
  const cleanLang = lang?.replace(/\/$/, '').toLowerCase();

  switch (cleanLang) {
    case 'en':
      return <EnHome />;
    case 'es':
    case undefined:
      return <Home />;
    default:
      return <Home />;
  }
};

const App = () => {
  return (
    <ModalProvider>
      <NavMenuProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/:lang/*" element={<HomeWrapper />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </NavMenuProvider>
    </ModalProvider>
  );
};

export default App;
